import React, { useMemo } from "react";
import { formatNumber } from "helpers/getNumberFormats";
import { InvoiceGrid } from "./styled-components";
import { Box, Grid, Typography } from "@mui/material";
import { accordionSx } from "./styles";

export const InvoiceBreakdown = ({ data }) => {
  const { taxRate, averageUnitPrice, quantity, total, subtotal } = data;

  const mapData = useMemo(() => [
      {
        key: "iva",
        label: `Desglose: ${taxRate} % IVA`,
        size: 2,
      },
      {
        key: "pu",
        label: `PU (sin IVA): $ ${formatNumber({ input: averageUnitPrice, decimals: 6 })}`,
        size: 2,
      },
      {
        key: "total",
        label: `Total Lt: ${formatNumber({ input: quantity, decimals: 6 })}`,
        size: 2,
      },
      {
        key: "totalB",
        label: `Subtotal: $${formatNumber({ input: subtotal })}`,
        size: 3,
      },
      {
        key: "totalN",
        label: `Total: $${formatNumber({ input: total })}`,
        size: 3,
      },
    ], [taxRate, averageUnitPrice, quantity, subtotal, total]);

  return (
    <Box sx={accordionSx.text}>
      <Grid container spacing={1}>
        {mapData.map(({ key, label, size }) => (
          <InvoiceGrid item xs={12} sm={size} key={key}>
            <Typography sx={accordionSx.heading}>{label}</Typography>
          </InvoiceGrid>
        ))}
      </Grid>
    </Box>
  );
};
